import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['categorySelect', 'unitSelect', 'unitField', 'unitWrapper', 'unitsByCategory'];

  connect() {
    this.unitsByCategory = JSON.parse(this.unitsByCategoryTarget.textContent);
  }

  changeCategory() {
    const category = this.categorySelectTarget.value;

    if (!category) {
      this.unitWrapperTarget.style.display = 'none';
      this.unitSelectTarget.innerHTML = '<option value="">Select a unit</option>';
      this.unitFieldTarget.value = '';
      return;
    }

    this.unitWrapperTarget.style.display = '';
    const units = this.unitsByCategory[category] || [];
    this.unitSelectTarget.innerHTML =
      '<option value="">Select a unit</option>' +
      units.map(([label, value]) => `<option value="${value}">${label}</option>`).join('');
    this.unitFieldTarget.value = '';
  }

  selectUnit() {
    this.unitFieldTarget.value = this.unitSelectTarget.value;
  }
}
